import useTrackWithUser from 'api/hooks/useTrackWithUser';
import { useEffect } from 'react';

// if the user has not logged the feature discovery event, log it
const useLogFeatureDiscovery = eventName => {
  const [trackWithUser] = useTrackWithUser(eventName);

  useEffect(() => {
    const hasSeenFeatureDiscovery = localStorage.getItem(eventName);
    if (!hasSeenFeatureDiscovery) {
      localStorage.setItem(eventName, 'true');
      trackWithUser();
    }
  }, [eventName, trackWithUser]);
};

export default useLogFeatureDiscovery;
